import { useCallback, useMemo } from "react";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useDescLanguageStore } from "src/store/useDescLanguageStore";
import { getDescText, getLangFieldByMinorCd, getLangFontSizeByMinorCd, getLangTextWrapByMinorCd, DescUiTarget } from "src/utils/descLanguage/descLanguageUtil";

//실제 버튼과 같은 랜더링에 사용되는 훅
export const useDescText = () => {
	const { descLanguageMap, selectedLanguageCd } = useDescLanguageStore();
	const { languageList } = useCommonCodeStore();

	const langField = useMemo(
		() => getLangFieldByMinorCd(languageList, selectedLanguageCd),
		[languageList, selectedLanguageCd]
	);

	const renderDescText = useCallback((commentCd: string, fallback = "") =>
			getDescText(descLanguageMap, commentCd, langField, fallback)
	,[descLanguageMap, langField]);

	const getFontSize = useCallback(
		(target: DescUiTarget) => getLangFontSizeByMinorCd(selectedLanguageCd, target),
		[selectedLanguageCd]
	);

	const getTextWrap = useCallback(
		(target: DescUiTarget) => getLangTextWrapByMinorCd(selectedLanguageCd, target),
		[selectedLanguageCd]
	);

	const getFormTitleWidth = useCallback((titles: string[], minWidth = 150, maxWidth = 230) => {
		const normalizedTitles = titles.filter((title) => title.trim().length > 0);
		if (normalizedTitles.length === 0) return minWidth;

		let measuredWidth = Math.max(...normalizedTitles.map((title) => title.length * 12));
		if (typeof document !== "undefined") {
			const canvas = document.createElement("canvas");
			const context = canvas.getContext("2d");
			if (context) {
				const fontFamily = window.getComputedStyle(document.body).fontFamily || "sans-serif";
				context.font = `18px ${fontFamily}`;
				measuredWidth = Math.max(...normalizedTitles.map((title) => context.measureText(title).width));
			}
		}

		return Math.min(maxWidth, Math.max(minWidth, Math.ceil(measuredWidth + 24)));
	}, []);

	return { renderDescText, getFontSize, getTextWrap, getFormTitleWidth, langField, selectedLanguageCd };
};
